import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FilterFieldType, FilterType} from '@core/interfaces/system/system-common';
import {GenericPopoutFilter} from '@core/interfaces/common/popout';
import {FilterState} from '@theme/components';
import {takeUntil} from 'rxjs/operators';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {GenericFilterGroupAccordion} from '@theme/components/layout/control-panel/generic-filter-group-accordion';
import {OutageFilterGroup} from '../../../../../pages/geospatial-viewer/api/geospatial-viewer-controls.service';

@Component({
    selector: 'ngx-generic-filter-group-accordion',
    templateUrl: './generic-filter-group-accordion.component.html',
    styleUrls: ['./generic-filter-group-accordion.component.scss'],
})
export class GenericFilterGroupAccordionComponent extends Unsubscribable implements OnInit {
    @Input() store: GenericFilterGroupAccordion;

    FilterFieldType = FilterFieldType;

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    public ngOnInit() {
        this.store.refresh$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.cd.detectChanges();
        });
    }

    public isFilterApplied(groupKey: string, f: GenericPopoutFilter): boolean {
        if (FilterType.isNumericFilterType(f.webFilterType)) {
            let _value = this.store.filtersFormGroupControls[f.fieldKey].value;
            return !(!_value?.min && !_value?.max);
        }
        if (FilterType.isDateRangeFilterType(f.webFilterType)) {
            let _value = this.store.filtersFormGroupControls[f.fieldKey].value;
            return !(!_value?.start && !_value?.end);
        } else if (FilterType.isSelectFilterType(f.webFilterType)) {
            let _value = this.store.filtersFormGroupControls[f.fieldKey].value;
            return _value?.length;
        }
        return false;
    }

    public isFilterAppliedInGroup(group: OutageFilterGroup): boolean {
        return (
            (group.filters &&
                group.filters
                    .map((f: GenericPopoutFilter) => this.isFilterApplied(group.groupKey, f))
                    .find((b) => b)) ||
            false
        );
    }

    public handleStateChangeSelect(state: FilterState, filter: GenericPopoutFilter): void {
        this.store.updateFiltersFullState(filter.fieldKey, state);
    }

    readonly FilterType = FilterType;
}
